export const GET_RESET_SEASONS_CONFIRMATION = (schoolName?: string) =>
  `You are about to set ${schoolName} seasons back to the default platform settings. Any configuring of sports to different seasons will be undone. Are you sure you want to reset?`;

export const MODAL_HEADING = "Reset seasons to default";

export const CLOSE_MODAL_BUTTON_LABEL = "Close";
export const RESET_SETTINGS_BUTTON_LABEL = "Reset to default settings";



// WEBPACK FOOTER //
// ./src/pages/director/seasons/seasonsPage/components/default-settings-modal/constants.ts